import AppPopover from "@/components/AppPopover";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
export default {
  name: "RevenueEvolutionCandle",
  components: {
    AppPopover,
    CurrencyValue,
    PercentageValue
  },
  emits: ["hoveringCandle"],
  props: {
    data: {
      type: Object,
      required: true
    },
    maxValue: {
      type: Number,
      default: 0
    },
    isLastest: {
      type: Boolean,
      default: false
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      periodRange: {
        "14 days": 1,
        "12 weeks": 7,
        "12 months": 30,
        "12 quarters": 90
      }
    };
  },
  computed: {
    height() {
      return this.maxValue <= 0 ? 0 : (Math.abs(this.data) / this.maxValue * 41).toFixed(1) + "px";
    },
    calculateDateString() {
      if (!this.data.label) {
        return "-";
      }
      const date1 = new Date(this.data.label);
      const date2 = new Date(date1);
      date2.setDate(date2.getDate() + this.periodRange[this.selected_period]);
      const date1_str = `${date1.getDate()} ${date1.toLocaleDateString(navigator.language, {
        month: "short"
      })}`;
      const date2_str = `${date2.getDate()} ${date2.toLocaleDateString(navigator.language, {
        month: "short"
      })} ${date2.getFullYear()}`;
      return `${date1_str} - ${date2_str}`;
    }
  },
  methods: {
    onHovering() {
      this.$emit("hoveringCandle", this.index);
    },
    onLeaving() {
      this.$emit("hoveringCandle", -1);
    }
  }
};